import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Modal, Form, Card, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import useAuth from '../../../hooks/useAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';
import { ref, uploadBytes } from 'firebase/storage';
import GalleryImage from '../../GalleryImage/GalleryImage';

const DashboardGallery = () => {
    const [modalShow, setModalShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [publishing, setPublishing] = useState(false);
    const [gallery, setGallery] = useState([]);
    const [canPublish, setCanPublish] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        fetch('https://gentle-tor-99938.herokuapp.com/gallery')
            .then(res => res.json())
            .then((data) => setGallery(data))
            .finally(() => setIsLoading(false));
    }, [])




    const { register, handleSubmit, reset, formState: { errors } } = useForm();




    const [imageUpload, setImageUpload] = useState(null);
    const { storage } = useAuth();
    const [uploadPreview, setUploadPreview] = useState(null);



    const uploadOnChange = (event) => {
        setCanPublish(true);
        setImageUpload(event.target.files[0]);
        setUploadPreview(URL.createObjectURL(event.target.files[0]));
    }

    const onSubmit = data => {
        if (imageUpload != null) {
            setPublishing(true);
            const imageRef = ref(storage, `gallery/gallery${gallery.length + 1}`);
            uploadBytes(imageRef, imageUpload)
                .then(() => {
                    data.blogID = gallery.length + 1;
                    data.image = `https://firebasestorage.googleapis.com/v0/b/degrees-steakhouse.appspot.com/o/gallery%2Fgallery${gallery.length + 1}?alt=media&token=478e5afb-568f-4b99-998a-25c9b949cffd`;
                    fetch(`https://gentle-tor-99938.herokuapp.com/add-gallery`, {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    })
                        .then(res => res.json())
                        .then(result => {
                            if (result.insertedId) {
                                setModalShow(false);
                                setGallery([...gallery, data]);
                                setUploadPreview(null);
                                setImageUpload(null);
                                setCanPublish(false);
                                swal("Image Uploaded", "We have successfully published your image to the gallery", "success");
                                reset();
                            }
                            else {
                                swal("Something Went Wrong!", "We couldn't publish your image. Please try again later", "error");
                            }
                        })
                        .finally(() => setPublishing(false));
                });
        }
    }



    return (
        <div>
            {
                isLoading
                    ?
                    <div className="spinner d-flex align-items-center justify-content-center">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                    </div>
                    :
                    <div className="my-5">
                        <div className="mb-4 bg-dark rounded-3 p-3 d-flex align-items-center justify-content-between">
                            <h2 className="m-0 text-white text-start fw-bold">Manage Gallery</h2>
                            <button onClick={() => setModalShow(true)} className="btn btn-success">Add Picture</button>

                            <Modal
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                                size="md"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="contained-modal-title-vcenter">
                                        Publish your image
                                    </Modal.Title>
                                </Modal.Header>
                                <Form
                                    onSubmit={handleSubmit(onSubmit)}
                                >
                                    <Card>

                                        <Modal.Body>

                                            <div className="d-flex justify-content-center">
                                                <input id="upload-blog" type="file" className="form-control border-0 d-none"
                                                    onChange={uploadOnChange}
                                                />
                                                <label className="btn btn-warning w-100" htmlFor="upload-blog" style={{
                                                    borderRadius: 0
                                                }}>
                                                    Upload Picture <i className="fa fa-upload"></i>
                                                </label>
                                            </div>

                                            {
                                                uploadPreview
                                                    ?
                                                    <Card.Img className="my-4" variant="top" src={uploadPreview}
                                                    />
                                                    :
                                                    <Card.Img className="my-4" variant="top"
                                                    />
                                            }

                                        </Modal.Body>
                                    </Card>
                                    <Modal.Footer>
                                        {
                                            publishing
                                                ?
                                                <button className="btn btn-success w-100 disabled d-flex align-items-center justify-content-center">
                                                    <span className="m-0">Loading</span>
                                                    <Spinner className="m-0 ms-2" animation="border" size="sm" />
                                                </button>
                                                :

                                                canPublish
                                                    ?
                                                    <button type="submit" className="btn btn-success w-100">
                                                        Publish Image <FontAwesomeIcon icon={faCircleCheck} />
                                                    </button>
                                                    :
                                                    <button type="submit" className="btn btn-secondary w-100 disabled btn-not">
                                                        Select an image
                                                    </button>

                                        }
                                    </Modal.Footer>
                                </Form>
                            </Modal>


                        </div>
                        <Container className="my-5 gallery">
                            <Row xs={1} md={3} lg={4} className="g-4 pb-5">
                                {
                                    gallery.map(image => <GalleryImage
                                        key={image.galleryID}
                                        image={image}
                                    />)
                                }
                            </Row>
                        </Container>
                    </div>
            }
        </div>
    );
};

export default DashboardGallery;